import {Component, Input, Output, EventEmitter, ViewEncapsulation, OnInit} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {AlphaChannel, ColorPickerModule} from 'ngx-color-picker';
import {ColorIconDirective} from "./coloricondirective";
import { CommonWidgetDirective } from "@wms/directives";
import { CommonModule } from '@angular/common';

export interface WMSColorpickerOptions {
  previewColor?: string;
  opacity?: string | number;
  presetColors?: string[];
  cpWidth?: string;
  cpAlphaChannel?: AlphaChannel;
  cpOKButton?: boolean;
  cpPosition?: string
  cpPositionOffset?: string
  cpPositionRelativeToArrow?: boolean
  cpDisableInput?: boolean
}

@Component({
  standalone: true,
  selector: 'wms-colorpicker',
  templateUrl: './colorpicker.component.html',
  imports: [
    FormsModule,
    ColorPickerModule,
    ColorIconDirective,
    CommonWidgetDirective,
    CommonModule
  ],
  styleUrls: ['./colorpicker.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class WMSColorpickerComponent {
  @Input()scopedatavalue:string;
  @Output() onBlur! : EventEmitter<string>;
  @Output() onSelect!: EventEmitter<string>;
  @Input() options!: WMSColorpickerOptions;
 
  /**
   * Set the color value on change event
   * @param $event
   */
  onChange($event: any): void {
    this.scopedatavalue = $event;
    if (this.options?.previewColor !== undefined) {
      this.options.previewColor = $event;
    }
  }

  /**
   * Emit blur event with set color value
   */
  handleBlur(): void {
    this.onBlur.emit(this.scopedatavalue);
  }

  handleSelect() {
    this.onSelect.emit(this.scopedatavalue)
  }

  constructor() {
    this.onBlur = new EventEmitter<string>();
    this.onSelect = new EventEmitter<string>();
  }
}
